/**
 * @generated SignedSource<<16ae368d660521cdef845b63f05fa81b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type searchTemplateCategoryQuery$variables = Record<PropertyKey, never>;
export type searchTemplateCategoryQuery$data = {
  readonly productMacroCategories: ReadonlyArray<{
    readonly categories: ReadonlyArray<{
      readonly name: string;
      readonly productCategoryId: number;
    }>;
    readonly name: string;
    readonly productMacroCategoryId: number;
  }>;
};
export type searchTemplateCategoryQuery = {
  response: searchTemplateCategoryQuery$data;
  variables: searchTemplateCategoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "isLibrary",
    "value": true
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productMacroCategoryId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productCategoryId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "searchTemplateCategoryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "ProductMacroCategory",
        "kind": "LinkedField",
        "name": "productMacroCategories",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCategory",
            "kind": "LinkedField",
            "name": "categories",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "productMacroCategories(isLibrary:true)"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "searchTemplateCategoryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "ProductMacroCategory",
        "kind": "LinkedField",
        "name": "productMacroCategories",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCategory",
            "kind": "LinkedField",
            "name": "categories",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v2/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          (v4/*:: as any*/)
        ],
        "storageKey": "productMacroCategories(isLibrary:true)"
      }
    ]
  },
  "params": {
    "cacheID": "35c20e9f44d582d7352cb8f7683d61b3",
    "id": null,
    "metadata": {},
    "name": "searchTemplateCategoryQuery",
    "operationKind": "query",
    "text": "query searchTemplateCategoryQuery {\n  productMacroCategories(isLibrary: true) {\n    productMacroCategoryId\n    name\n    categories {\n      productCategoryId\n      name\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e55c1498f30e59658931e8226ad61965";

export default node;
